import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import BuildCircleRoundedIcon from "@mui/icons-material/BuildCircleRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { AnalyticsDashboard } from "../types";

interface SummaryCardsProps {
  dashboard?: AnalyticsDashboard | null;
}

const SummaryCards = ({ dashboard }: SummaryCardsProps) => {
  const cards = [
    {
      title: "Total Spare Parts",
      color: "#2563ff", note: "Across all categories",
      value: dashboard?.inventory.totalParts ?? 0,
      icon: <Inventory2RoundedIcon color="primary" />,
    },
    {
      title: "Inventory Value",
      color: "#10a467", note: "Total stock value",
      value: `Rs ${dashboard?.inventory.totalValue?.toLocaleString() ?? 0}`,
      icon: <AccountBalanceWalletRoundedIcon color="success" />,
    },
    {
      title: "Open Tickets",
      color: "#f43f5e", note: "Maintenance tickets",
      value: dashboard?.maintenance.openTickets ?? 0,
      icon: <BuildCircleRoundedIcon color="warning" />,
    },
    {
      title: "Low Stock",
      color: "#f59e0b", note: "Items below threshold",
      value: dashboard?.inventory.lowStockItems ?? 0,
      icon: <WarningAmberRoundedIcon color="error" />,
    },
  ];

  return (
    <Grid container spacing={1.5} mb={1.5}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.title}>
          <Card variant="outlined">
            <CardContent sx={{ p: 2.25, "&:last-child": { pb: 2.25 } }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Box sx={{ width: 50, height: 50, flexShrink: 0, display: "grid", placeItems: "center", borderRadius: 2, bgcolor: card.color + "15", "& svg": { color: card.color, fontSize: 28 } }}>{card.icon}</Box>
                <Stack spacing={0.5}>
                  <Typography variant="caption" color="text.secondary">{card.title}</Typography>
                  <Typography variant="h6" fontWeight={800} sx={{ fontVariantNumeric: "tabular-nums" }}>
                    {card.value}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">{card.note}</Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCards;
